import React from 'react';
import { Typography } from '@mui/material';

interface FormTitleProps {
    title: string;
}

export const FormTitle = ({ title }: FormTitleProps) => (
    <Typography
        sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', letterSpacing: '0.1px' }}
        id="emissions-allocation-form-title"
    >
        {title}
    </Typography>
);